import { render, staticRenderFns } from "./LedStationViewer.vue?vue&type=template&id=5638f272&scoped=true"
import script from "./LedStationViewer.vue?vue&type=script&lang=js"
export * from "./LedStationViewer.vue?vue&type=script&lang=js"
import style0 from "./LedStationViewer.vue?vue&type=style&index=0&id=5638f272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638f272",
  null
  
)

export default component.exports